
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface GameHeaderProps {
  title: string;
  onBackClick: () => void;
}

const GameHeader = ({ title, onBackClick }: GameHeaderProps) => {
  const navigate = useNavigate();
  
  // Improved back handler with fallback
  const handleBack = () => {
    try {
      // First try the provided onBackClick
      onBackClick();
      
      // If there's any error or it doesn't work, we'll try our own navigation as backup
      setTimeout(() => {
        // Check if we're still on the same page after a delay
        if (location.pathname.includes('/game/')) {
          console.log('Fallback navigation to home');
          navigate('/', { replace: true });
        }
      }, 300);
    } catch (error) {
      console.error('Error handling back button:', error);
      // Navigate home as fallback
      navigate('/', { replace: true });
    }
  };

  return (
    <div className="bg-white shadow-sm p-4">
      <div className="container mx-auto max-w-4xl">
        <div className="flex items-center justify-between">
          <Button 
            variant="outline" 
            onClick={handleBack}
            className="flex items-center space-x-2"
          >
            <ArrowLeft className="w-4 h-4" />
            <span>Back</span>
          </Button>
          <h1 className="text-xl font-semibold text-center">{title}</h1>
          <div className="w-24"></div> {/* Empty div to balance the layout */}
        </div>
      </div>
    </div>
  );
};

export default GameHeader;
